import Cookies from "universal-cookie";

const cookies = new Cookies();

export const PERSISTENCE_OPTIONS = {
  path: "/",
  maxAge: 365 * 24 * 60 * 60,
  sameSite: "lax",
};

function setItem(key, value, options = {}) {
  cookies.set(key, value, options);
}

function getItem(key) {
  return cookies.get(key);
}

function removeItem(key, options = {}) {
  cookies.remove(key, options);
}

export const storageService = { setItem, getItem, removeItem };
